import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Stack,
  Avatar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CallIcon from "@mui/icons-material/Call";

// तुझा लोगो पाथ
import LogoImg from "../images/logo2.jpg"; 

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "auto", md: "85vh" },
        background: "linear-gradient(135deg, #e65100 0%, #ef6c00 50%, #f57c00 100%)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        py: { xs: 8, md: 4 }, 
      }}
    >
      <Typography
        sx={{
          position: "absolute",
          right: { xs: "-5%", md: "5%" },
          top: "15%",
          fontSize: { xs: "12rem", md: "28rem" },
          color: "rgba(255,255,255,0.06)",
          zIndex: 0,
          fontWeight: 900,
          userSelect: "none",
        }}
      >
        ॐ
      </Typography>

      <Container maxWidth="lg" sx={{ zIndex: 1 }}>
        <Grid container spacing={4} alignItems="center">
          
          <Grid item xs={12} md={7}>
            <Stack 
              spacing={3} 
              alignItems={{ xs: "center", md: "flex-start" }} 
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  bgcolor: "rgba(255,255,255,0.2)",
                  px: 2,
                  py: 0.8,
                  borderRadius: "50px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  mt: { xs: 4, md: 8 }, 
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                }}
              >
                <Box sx={{ width: 8, height: 8, bgcolor: "#fff", borderRadius: "50%", mr: 1.5 }} />
                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.85rem", letterSpacing: 0.5 }}>
                  दिगंबर जैन आध्यात्मिक व्यासपीठ
                </Typography>
              </Box>

              <Typography
                variant="h1"
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: "2.5rem", md: "4rem" },
                  lineHeight: 1.1,
                  textShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                स्वरसागरामृत परिवार
              </Typography>

              <Box>
                <Typography variant="h5" sx={{ fontWeight: 500, mb: 1, fontSize: { xs: "1.1rem", md: "1.4rem" } }}>
                  संगीत, पूजा-विधान व साधनसामग्रीचे विश्वसनीय केंद्र
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, fontStyle: "italic", fontSize: "0.95rem" }}>
                  A Trusted Spiritual Platform for Digambar Jain Music, Worship & Rituals
                </Typography>
              </Box>

              <Typography variant="body1" sx={{ maxWidth: "550px", lineHeight: 1.7, opacity: 0.95, fontSize: "1rem" }}>
                संगीत पूजा, अभिषेक पाठ, स्तोत्र, जयमाला आणि विधान सामग्री — हिंदी, मराठी, कन्नड भाषांमध्ये संपूर्ण अर्थ व शुद्ध उच्चारणासह
              </Typography>

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ pt: 2, width: { xs: "100%", sm: "auto" } }}>
                <Button
                  variant="contained"
                  size="large"
                  startIcon={<PlayCircleFilledIcon />}
                  sx={{
                    bgcolor: "#fff",
                    color: "#e65100",
                    fontWeight: 700,
                    px: 4,
                    py: 1.5,
                    borderRadius: "10px",
                    textTransform: "none",
                    fontSize: "1.05rem",
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  संगीत ऐका
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  startIcon={<MenuBookIcon />}
                  sx={{
                    color: "#fff",
                    borderColor: "#fff",
                    borderWidth: "2px",
                    fontWeight: 700,
                    px: 4,
                    py: 1.5,
                    borderRadius: "10px",
                    textTransform: "none",
                    fontSize: "1.05rem",
                    "&:hover": { borderWidth: "2px", bgcolor: "rgba(255,255,255,0.1)" },
                  }}
                >
                  विधान पहा
                </Button>
              </Stack>

              <Box sx={{ pt: 4 }}>
                <Typography variant="caption" sx={{ display: "block", opacity: 0.8, fontSize: "0.85rem", mb: 0.5 }}>
                  प्रतिष्ठाचार्य
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                  पं. श्री सागर पद्माण्णा उपाध्ये
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1} justifyContent={{ xs: "center", md: "flex-start" }}>
                  <CallIcon sx={{ fontSize: 18 }} />
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    7972970108
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Grid>

          {/* ── उजवीकडील लोगो विभाग (Position Updated) ── */}
          <Grid 
            item 
            xs={12} 
            md={5} 
            sx={{ 
              display: "flex", 
              justifyContent: { xs: "center", md: "flex-end" }, // मोबाईलवर सेंटर, डेस्कटॉपवर राईटला
              pr: { md: 5} // थोडी राईट मार्जिन
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: { xs: 260, md: 380 }, 
                height: { xs: 260, md: 380 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(12px)",
                borderRadius: "50%",
                border: "2px solid rgba(255,255,255,0.25)",
                boxShadow: "0 20px 45px rgba(0,0,0,0.2)",
              }}
            >
              <Avatar
                src={LogoImg}
                alt="Logo"
                sx={{
                  width: { xs: 240, md: 350 }, 
                  height: { xs: 240, md: 350 },
                  bgcolor: "transparent",
                  border: "4px solid rgba(255,255,255,0.5)"
                }}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;